import cisFertigationDataConfig from '@/api/config/cisFertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

function useDetailCisFertigationMode(interfaceId: number, id: number) {
  return useQuery({
    queryKey: [queryKeys.cisFertigationMode, id],
    queryFn: async () => {
      const { data } = await cisFertigationDataConfig.getFertigationMode(interfaceId, id)
      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
    enabled: !!id,
  })
}

export default useDetailCisFertigationMode
